export default "__VITE_ASSET__CohHZ3S2__"